export default function kebabCaseToCamelCase(str: string): string {
  return str.replace(/-([a-z])/g, (match) => match[1].toUpperCase());
}
